"use client";
export { Image as default } from "../../../_Builtin/Basic";
